import React, { useEffect, useMemo, useState, Card, CardBody } from 'react';
import ApexChart from '../../components/ApexChart.jsx'
import { Chip } from '@nextui-org/react';


const DashboardSaleNPurchaseChart = ({ dataMonth, dataJobWork, dataParty, dataProduct, dataFilter, isSaleChart }) => {

  const ENUM_KEY = {
    Month: "mnth",
    JobWork: isSaleChart ? "Sales/Jobwork" : "Purchase/Jobwork",
    Party: "party",
    Product: "item_desc"
  }

  const funGetFilterData = (data, key, isFilterKey) => {
    let newData = data
    let filterKey = ""

    if (dataFilter && dataFilter?.length > 0) {
      let filterKeyData = dataFilter.filter((ele) => ele.key == String(key))
      if (filterKeyData && filterKeyData?.length > 0) {
        filterKey = filterKeyData[0].value
        newData = data.filter((ele) => ele[key] == String(filterKeyData[0].value))
      }
    }
    if (isFilterKey)
      return filterKey
    else
      return newData
  }

  let dataListMonth = useMemo(() => {
    let Data = funGetFilterData(dataMonth, ENUM_KEY.Month, false)
    return Data && Data?.map(item => Math.round(item.NetAmount * 100) / 100)
  }, [dataMonth, dataFilter])

  let labelListMonth = useMemo(() => {
    let Data = funGetFilterData(dataMonth, ENUM_KEY.Month, false)
    return Data && Data?.map(item => item[ENUM_KEY.Month])
  }, [dataMonth, dataFilter])

  let dataListJobWork = useMemo(() => {
    let Data = funGetFilterData(dataJobWork, ENUM_KEY.JobWork, false)
    return Data && Data?.map(item => Math.round(item.NetAmount * 100) / 100)
  }, [dataJobWork, dataFilter])

  let labelListJobWork = useMemo(() => {
    let Data = funGetFilterData(dataJobWork, ENUM_KEY.JobWork, false)
    return Data && Data?.map(item => item[ENUM_KEY.JobWork])
  }, [dataJobWork, dataFilter])

  let dataListParty = useMemo(() => {
    let Data = funGetFilterData(dataParty, ENUM_KEY.Party, false)
    return Data && Data?.map(item => Math.round(item.NetAmount * 100) / 100)
  }, [dataParty, dataFilter])

  let labelListParty = useMemo(() => {
    let Data = funGetFilterData(dataParty, ENUM_KEY.Party, false)
    return Data && Data?.map(item => item[ENUM_KEY.Party])
  }, [dataParty, dataFilter])


  let dataListProduct = useMemo(() => {
    let Data = funGetFilterData(dataProduct, ENUM_KEY.Product, false)
    return Data && Data?.map(item => Math.round(item.NetAmount * 100) / 100)
  }, [dataProduct, dataFilter])

  let labelListProduct = useMemo(() => {
    let Data = funGetFilterData(dataProduct, ENUM_KEY.Product, false)
    return Data && Data?.map(item => item[ENUM_KEY.Product])
  }, [dataProduct, dataFilter])

  const Charts = [
    {
      title: "JobWork",
      data: dataListJobWork,
      label: labelListJobWork,
      type: "donut",
      key: ENUM_KEY.JobWork
    },
    {
      title: "Month",
      data: dataListMonth,
      label: labelListMonth,
      type: "donut",
      key: ENUM_KEY.Month,
    },
    {
      title: "Party",
      data: dataListParty,
      label: labelListParty,
      type: "donut",
      key: ENUM_KEY.Party,
    },
    {
      title: "Product",
      data: dataListProduct,
      label: labelListProduct,
      type: "donut",
      key: ENUM_KEY.Product,
    }

  ]

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
     
      {
        Charts && Charts?.length > 0 &&
        Charts?.map((item) => {
          return (
            <div className="shadow bg-gray-50">
              <Chip color='warning' className='w-full'  >{item.title}
                {dataFilter && dataFilter.length > 0 ? " - " + funGetFilterData(item.data, item.key, true) : ""}
              </Chip>
              <ApexChart labelList={item.label} dataList={item.data} type={item.type} showlegend={true} />
            </div>
          )
        })
      }


    </div>
  );
};

export default DashboardSaleNPurchaseChart;
